<template>
  <div :class="['popup', modal2 ? 'active' : '']" :style="'background:' + cor">
    <header class="popup__header">
      <nav>
        <a href=""
          ><img src="../assets/img/logo.svg" alt="Logo JBS 70 anos"
        /></a>
        <button @click.prevent="handdleMenu">Fechar</button>
      </nav>
    </header>
    <div class="pop__wrapper">
      <div class="container">
        <figure>
          <a :href="linkimagem1" target="_blank">
            <img :src="imagem1" alt="" />
          </a>
          <a :href="linkimagem2" target="_blank">
            <img :src="imagem2" alt="" />
          </a>
        </figure>
        <div class="popup__text">
          <h2>{{ titulo }}</h2>
          <p>{{ texto }}</p>
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: [
    "cor",
    "titulo",
    "texto",
    "imagem1",
    "linkimagem1",
    "imagem2",
    "linkimagem2",
    "menuopen",
  ],
  data() {
    return {};
  },
  methods: {
    handdleMenu() {
      this.$store.commit("TOGGLE_MODAL2", false);
      document.querySelector("body")?.classList.remove("no-scroll");
    },
  },
  computed: {
    ...mapGetters(["modal2"]),
  },
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  z-index: -1;
  opacity: 0;
  transition: 0.4s ease-in-out;
  overflow: scroll;
  height: 100%;
  &.active {
    z-index: 9999999;
    opacity: 1;
  }

  &__text {
    position: relative;
    span {
      position: absolute;
      left: -70px;
      bottom: 0px;
      width: 65px;
      color: color(cWhite);
      @include media("<=desktop") {
        right: initial;
        left: 0px;
        bottom: -100px;
      }
      strong {
        color: color(cBlue4);
        font-family: font(primary);
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 116.5%;
        background: color(cWhite);
      }
      i {
        display: block;
        font-size: 1.3rem;
      }
    }
  }

  .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding-top: 40px;
    @include media("<=desktop") {
      display: flex;
      flex-direction: column;
      gap: 50px;
      padding: 0 20px;
    }
  }

  h2 {
    color: color(cWhite);
    font-family: font(primary);
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%; /* 25.2px */
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }
  p {
    color: color(cWhite);
    font-family: font(primary);
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }
  a {
    display: inline-block;
    transition: 0.3s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
    &:nth-child(2) {
      margin-top: -270px;
      position: relative;
      z-index: 2;
    }
  }
  &__header {
    padding: 30px 45px;
    nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      button {
        background: none;
        border: none;
        color: color(cWhite);
        font-family: font(primary);
        font-size: 0.625rem;
        font-style: normal;
        font-weight: 700;
        line-height: 135%; /* 0.84375rem */
        text-transform: uppercase;
        transition: 0.3s ease-in-out;
        cursor: pointer;
        position: absolute;
        right: 55px;
        top: 45px;

        &:hover {
          color: color(cBlue);
        }

        &::before {
          content: "\e902";
          font-family: "icomoon" !important;
          display: block;
          text-align: left;
          margin-block: 0.5rem;
          font-size: 0.8rem;
        }
      }
    }
  }
}
</style>
